import { useMemo } from 'react';

import { type WorkspaceMemberResponseWithRoles } from '@air/api/types';

import { useFetchMembers } from '~/swr-hooks/members/useFetchMembers';

export const useUserByAccountIdOrEmail = ({
  userId,
}: {
  userId: WorkspaceMemberResponseWithRoles['accountId'] | WorkspaceMemberResponseWithRoles['email'] | undefined;
}): { user: WorkspaceMemberResponseWithRoles | undefined } => {
  const { data: members } = useFetchMembers();

  const user = useMemo(
    () => (userId ? members?.find(({ email, accountId }) => email === userId || accountId === userId) : undefined),
    [members, userId],
  );

  return {
    user,
  };
};
